<template>
	<i class="icon icon-ordem-2"></i>
</template>

<script>
export default {}
</script>
